import { RootState } from '#/app/store/store'

export const balanceSelector = (state: RootState) => Math.floor(state.balance.balance)
